export interface INpsResponse {
  id: number;
  retailerId: number;
  retailerName: string | null;
  userId: number;
  userEmail: string | null;
  score: number;
  feedback: string | null;
  triggerPoint: number;
  submittedAt: string;
}

export interface INpsResponsesResult {
  items: INpsResponse[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface IRecordNpsPopupShownRequest {
  triggerPoint: NpsTriggerPoint;
}

export interface IRecordNpsPopupShownResponse {
  npsResponseId: number;
}

export interface ISubmitNpsRequest {
  npsResponseId: number;
  score: number;
  feedback: string | null;
}

export interface IGetLastNpsShownResponse {
  lastShownAt: string | null;
}

export interface INpsState {
  isModalOpen: boolean;
  selectedScore: number | null;
  npsResponseId: number | null;
  isSubmitting: boolean;
  error: string | null;
}

export enum NpsTriggerPoint {
  BeforeOrder = 'BeforeOrder',
  AfterOrder = 'AfterOrder',
  Manual = 'Manual',
}

export type NpsFrequency = 'Never' | 'Weekly' | 'Monthly';
